<div class="redirect-container">
  <h1>
    Redirecting in {{ duration }} {{ duration === 1 ? 'second' : 'seconds' }}...
  </h1>

  <div>
    <button
      type="button"
      mat-raised-button
      color="primary"
      (click)="launchRedirect()"
    >
      Go To {{ redirectPageName }} <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
